// Copy kept in one place for the custom attendance screen.
export const copy = {
  of: 'de',
  showing: 'Mostrando',
  situation: 'Situação',
  title: 'Atendimentos',
  filters: 'Filtros',
  clearAll: 'Limpar tudo',
  clearFilters: 'Limpar filtros',
  search: 'Buscar protocolo, contato ou telefone',
  searchLabel: 'Busca',
  refresh: 'Atualizar',
  report: 'Gerar relatório',
  conclude: 'Concluir atendimentos',
  where: 'ONDE E QUEM',
  when: 'QUANDO',
  all: 'Todos',
  allFemale: 'Todas',
  anyDate: 'Qualquer data',
  pending: 'Pendente',
  in_progress: 'Em andamento',
  resolved: 'Concluído',
  protocol: 'PROTOCOLO',
  contact: 'CONTATO',
  responsible: 'RESPONSÁVEL',
  channel: 'CANAL',
  dates: 'DATAS',
  inactivity: 'INATIVO HÁ',
  times: 'TEMPOS',
  unassigned: 'Sem responsável',
  start: 'Início',
  finish: 'Conclusão',
  firstReply: '1ª resposta',
  total: 'Total',
  empty: 'Nenhum atendimento com esses filtros',
  emptyHelp: 'Tente remover algum filtro ou aumentar o período.',
  loading: 'Carregando atendimentos…',
  previous: 'Anterior',
  next: 'Próxima',
  oldest: 'Mais antigos primeiro',
  newest: 'Mais recentes primeiro',
  selected: 'selecionados',
  selectAll: 'Selecionar todos os',
  thisFilter: 'deste filtro',
  clearSelection: 'Limpar seleção',
  selectPage: 'Selecionar esta página',
  selectRow: 'Selecionar atendimento',
  openConversation: 'Abrir conversa',
  cancel: 'Cancelar',
  close: 'Fechar',
  apply: 'Aplicar',
  clear: 'Limpar',
  searchOptions: 'Buscar…',
  selectOptions: 'Selecionar todos',
  from: 'Data inicial',
  to: 'Data final',
  any: 'Qualquer',
  custom: 'PERSONALIZADO',
  moreThan: 'Mais de',
  days: 'dias',
  activeHelp:
    'Atendimentos que tiveram alguma mensagem pública do cliente ou da equipe dentro deste período.',
  periodError:
    'Informe as duas datas. A data inicial deve ser anterior ou igual à data final.',
  inactivityError: 'Informe um número inteiro de dias entre 1 e 99999.',
  today: 'Hoje',
  last7: 'Últimos 7 dias',
  last30: 'Últimos 30 dias',
  thisMonth: 'Este mês',
  lastMonth: 'Mês passado',
  scope: 'Filtro aplicado',
  pendingPlural: 'Pendentes',
  progressPlural: 'Em andamento',
  ignored: 'Já concluídos (ignorados)',
  confirmTitle: 'Concluir',
  confirmQuestion: 'atendimentos?',
  confirmAll:
    'Todos os atendimentos deste filtro serão marcados como concluídos.',
  confirmIds: 'Os protocolos abaixo serão marcados como concluídos.',
  history:
    'Os atendimentos saem das filas e continuam no histórico do contato. Uma nova mensagem segue a política de abertura ou reabertura do canal.',
  typeConfirm: 'Digite CONCLUIR para confirmar',
  confirmWord: 'CONCLUIR',
  result: 'Resultado da conclusão',
  sale_won: 'Venda realizada',
  sale_lost: 'Venda perdida',
  other: 'Outro motivo',
  concluding: 'Concluindo atendimentos…',
  backgroundHelp:
    'Pode fechar esta janela. O trabalho continua e o progresso fica disponível nesta página.',
  viewResolved: 'Ver concluídos',
  completedSuffix: 'atendimentos concluídos.',
  ignoredSuffix: 'ignorados',
  failedSuffix: 'falhas',
  reportHelp: 'O relatório usa os filtros aplicados na página.',
  what: 'O que entra',
  allFilter: 'Todo o filtro',
  onlySelected: 'Só os selecionados',
  format: 'Formato',
  excel: 'Excel (.xlsx)',
  excelHelp: 'Para analisar e filtrar',
  csv: 'CSV',
  csvHelp: 'Para importar em outro sistema',
  columns: 'Colunas',
  deselectColumns: 'Desmarcar todas',
  completeModel: 'Modelo completo (30 colunas)',
  extraColumns: 'Campos complementares do modelo',
  reportReady: 'Relatório pronto',
  lines: 'linhas',
  download: 'Baixar',
  reports: 'Notificações de relatórios',
  generating: 'Estamos gerando seu relatório',
  generatingHelp:
    'São mais de 5.000 atendimentos. Quando ficar pronto, o link aparece nas notificações e será enviado ao seu e-mail.',
  gotIt: 'Entendi',
  available:
    'Arquivo disponível por 24 horas. O download exige acesso à conta e aos atendimentos.',
  requestError:
    'Não foi possível realizar esta operação. Atualize a lista e tente novamente.',
  loadError: 'Não foi possível carregar os atendimentos. Tente novamente.',
  changed:
    'A seleção mudou. Confira novamente a quantidade antes de confirmar.',
  operationFailed:
    'Não foi possível concluir a operação. Confira o resultado e tente novamente.',
  noColumns: 'Selecione pelo menos uma coluna.',
  noOptions: 'Nenhuma opção encontrada',
};
export const filterDefinitions = [
  {
    key: 'inbox_ids',
    label: 'Canal',
    options: 'inboxes',
    icon: 'i-lucide-messages-square',
    kind: 'list',
  },
  {
    key: 'team_ids',
    label: 'Equipe',
    options: 'teams',
    icon: 'i-lucide-users',
    kind: 'list',
  },
  {
    key: 'assignee_ids',
    label: 'Usuário',
    options: 'agents',
    icon: 'i-lucide-user-round',
    kind: 'list',
  },
  {
    key: 'labels',
    label: 'Etiqueta',
    options: 'labels',
    icon: 'i-lucide-tag',
    kind: 'list',
  },
  {
    key: 'created',
    label: 'Criado em',
    icon: 'i-lucide-calendar-days',
    kind: 'date',
  },
  {
    key: 'resolved',
    label: 'Concluído em',
    icon: 'i-lucide-calendar-check',
    kind: 'date',
  },
  {
    key: 'active',
    label: 'Ativo no período',
    icon: 'i-lucide-activity',
    kind: 'date',
  },
  {
    key: 'inactive_days',
    label: 'Inatividade',
    icon: 'i-lucide-clock-3',
    kind: 'inactivity',
  },
];
